import React, { useState } from 'react'
import './index.scss'
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import useAxiosInterceptors from '../config/axios-config';

const LoginComponent = (props) => {

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [emailError, setEmailError] = useState('')
    const [passwordError, setPasswordError] = useState('')
    const [loading, setLoading] = useState('')

    const navigate = useNavigate();

    const onButtonClick = () => {
        // Set initial error values to empty
        setEmailError('')
        setPasswordError('')

        // Check if the user has entered both fields correctly
        if ('' === email) {
            setEmailError('Please enter your email')
            return
        }

        if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
            setEmailError('Please enter a valid email')
            return
        }

        if ('' === password) {
            setPasswordError('Please enter a password')
            return
        }

        if (password.length <= 7) {
            setPasswordError('The password must be 8 characters or longer')
            return
        }
        var user = {
            userName: email,
            password: password
        };
        setLoading(true);
        useAxiosInterceptors.post(`app/common/v1/auth`, user)
            .then(res => {
                if (res.data.status == 'SUCCESS') {
                    localStorage.setItem("auth-token", res.data.authToken);
                    navigate("/certificates");
                } else {
                    toast.error("Invalid credentials", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: 0,
                        type: "warning"
                    });
                    // navigate("/certificates");
                }
            })
            .catch(ex => {
                console.log(ex)
            })
            .finally(() => {
                setLoading(false);
            });
        // navigate("/certificates");
    }

    return (
        <>
            {loading ?
                <>
                    <div className="overlay">
                        <div className="overlay__inner">
                            <div className="overlay__content">
                                <span className="spinner"></span>
                            </div>
                        </div>
                    </div>
                </>
                :
                <>
                    <div className='root'>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-4 info-section pt-5">
                                    <h1>Document Signer</h1>
                                    <hr></hr>
                                    <p>Use digital signer to securely configure and sign your PDF files. You can start using by configuring your digital signatures in the dashboard and start signing the documents</p>
                                </div>
                                <div className="col-lg-4 offset-lg-4">
                                    <div className="glass">
                                        <div className="row">
                                            <div className="col-lg-8 offset-lg-2">
                                                <p style={{ fontSize: "18px" }} className='text-center mt-4'>Login to continue</p>
                                                <hr></hr>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-12 mt-4">
                                                <label>Username</label>
                                                <input
                                                    value={email}
                                                    placeholder='Enter your email here'
                                                    type='text'
                                                    onChange={(ev) => setEmail(ev.target.value)}
                                                    className='form-control'></input>
                                                <label className="errorLabel">{emailError}</label>

                                            </div>
                                            <div className="col-lg-12 mt-2">
                                                <label>Password</label>
                                                <input
                                                    type='password' value={password}
                                                    placeholder="Enter your password here"
                                                    onChange={(ev) => setPassword(ev.target.value)}
                                                    className='form-control'></input>
                                                <label className="errorLabel">{passwordError}</label>

                                            </div>
                                            <div className="col-lg-12 mt-2">
                                                <input type='submit' className='btn btn-secondary btn-block' onClick={onButtonClick} value="Login"></input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="container"></div> */}
                        {/* <form onSubmit={this.handleSubmit}>
                    <label>
                        Person Name:
                        <input type="text" name="name" onChange={this.handleChange} />
                    </label>
                    <button type="submit">Add</button>
                </form> */}
                    </div>
                </>}
        </>
    )
}

export default LoginComponent;
